export const NAME = 'auth';
export default NAME;
